import axios from 'axios';
import { UITheme } from '@harver/shared-ui';

import { ThemeConfig, parseTheme } from './theme';
import { getSchedulingServerURL } from '../HarverPages/shared/helper';

export interface LanguageContent {
    interviewConfirmation: {
        browserTitle: string;
        title: string;
        heading: string;
        cancelNote: string;
        cancelOrRescheduleNote: string;
    };
    interviewUnavailable: {
        title: string;
        p1: string;
        p2: string;
        submitButtonLabel: string;
        thankYouPage: {
            title: string;
            message: string;
        };
        candidateReasons: string[];
        reasonSelectionLabel: string;
    };
    interviewCancellation: {
        title: string;
        heading: string;
        reasonSelectionLabel: string;
        messageInputLabel: string;
        cancelButtonLabel: string;
        candidateReasons: string[];
        recruiterReasons: string[];
        thankYouPage: {
            title: string;
            message: string;
            note: string;
        };
        alreadyCancelledInterview: {
            title: string;
            p1: string;
            p2: string;
        };
        alreadyUnavailableInterview: {
            title: string;
            message: string;
        };
        alreadyCompletedInterview: {
            title: string;
            message: string;
        };
    };
    rescheduling: {
        title: string;
        message: string;
        reasons: string[];
        noAvailability: {
            title: string;
            message: string;
        };
        reasonSelectionLabel: string;
    };
    linkDisabled: {
        title: string;
        p1: string;
        p2: string;
    };
    interviewExpired: {
        title: string;
        p1: string;
        p2: string;
    };
    scheduler: {
        p1: string;
        timezoneLbl: string;
        p3: string;
        requestNewSlot: string;
        requestNewSlotLinkLbl: string;
        p4: string;
        btn: string;
        availableSlotNotFound: string;
        confirmationFailed: string;
    };
    noSlots: {
        title: string;
        p1: string;
        btn: string;
    };
    interviewSettingDisabled: {
        title: string;
        p1: string;
        note: string;
    };
    locale: string;
    openInviteLinkExpire: {
        browserTitle: string;
        title: string;
        p1: string;
    };
    openInviteLinkNotExist: {
        browserTitle: string;
        title: string;
        p1: string;
    };
    openInviteRegistration: {
        browserTitle: string;
        title: string;
        p1: string;
        firstName: string;
        lastName: string;
        email: string;
        termsAndConditions: string;
        button: string;
        validate: {
            firstNameRequired: string;
            lastNameRequired: string;
            emailRequired: string;
            emailInvalid: string;
            termsAndConditionsRequired: string;
            recaptchaTokenRequired: string;
            recaptchaVerificationFailed: string;
        };
    };
    openInviteEmailUnique: {
        browserTitle: string;
        title: string;
        p1: string;
    };
    openInviteRegistrationSuccess: {
        browserTitle: string;
        title: string;
        p1: string;
    };
    openInviteRegistrationFail: {
        browserTitle: string;
        title: string;
        p1: string;
        button: string;
    };
    loading: {
        p: string;
    };
    cookieBanner: {
        p1: string;
        button: string;
    };
    timeslotsLoader: {
        title: string;
        p1: string;
        p2: string;
    };
    openInviteTooManyRequests: {
        browserTitle: string;
        title: string;
        p1: string;
        button: string;
    };
}

interface Config {
    theme?: ThemeConfig;
    content?: LanguageContent;
    favicon?: string;
}

export interface OrganizationConfig extends Config {
    theme: UITheme;
    content: LanguageContent;
    favicon: string;
}

function parseFavicon(path?: string): string {
    return path || `${process.env.PUBLIC_URL}/favicon.png`;
}

export async function getBrandedConfig(calendarEventId: string): Promise<OrganizationConfig> {
    const { data: organizationConfig } = await axios.get(`${getSchedulingServerURL()}/interview/branded-data`, {
        params: { ref: calendarEventId },
    });

    return {
        content: organizationConfig.content,
        theme: parseTheme(organizationConfig.theme),
        favicon: parseFavicon(organizationConfig.favicon),
    };
}

export async function getBrand(linkId: string): Promise<OrganizationConfig> {
    const { data: organizationConfig } = await axios.get(`${getSchedulingServerURL()}/interview/brand/${linkId}`);

    return {
        content: organizationConfig.content,
        theme: parseTheme(organizationConfig.theme),
        favicon: parseFavicon(organizationConfig.favicon),
    };
}
